import React, { useCallback } from 'react';
import { toHHMMSS } from '../../../util/util';
import { getLowQThumbnail } from '../../../util/media-data-util';

import './MediaItem.scss';

interface MediaItemProps {
	data: any;
	isPlaying: boolean;
	primaryColor: string;
	onClick: () => void;
}

const MediaItem = ({ data, isPlaying, primaryColor, onClick }: MediaItemProps) => {
	const {
		title,
		resources
	} = data;

	const thumbnailUrl = getLowQThumbnail({ posters: resources[0].posters, images: resources[0].images });

	const onKeyDown = useCallback((event) => {
		if (event.key === 'Tab') {
			event.stopPropagation();
			return;
		}

		if (event.key === 'Enter') {
			onClick();
		}
	}, []);

	return (
		<div className={`media-container ${isPlaying ? 'media-container--highlighted' : ''}`} onClick={onClick} tabIndex={0} onKeyDown={onKeyDown}>
			{thumbnailUrl ? (
				<img className="media-thumbnail" src={thumbnailUrl} />
			) : (
				<div className="media-thumbnail" style={{ backgroundColor: primaryColor }} />
			)}

			<div className="media-info">
				<div className="media-title">{title}</div>
				<div className="media-duration">{toHHMMSS(resources[0].duration ?? 0)}</div>
			</div>
		</div>
	);
};

export default MediaItem;
